import React from 'react';
import { Box, ButtonGroup } from '@chakra-ui/react';
import LinkButton from '../../../components/custom/LinkButton';
import AddUserForm from '../../../components/forms/user/AddUserForm';
import PageHeader from '../../../components/common/PageHeader';

export default function AddUser() {
    return (
        <>
            <div className='admin-page-header'>
                <PageHeader headerTitle={"ユーザ登録"} />
                <ButtonGroup gap={2}>
                    <LinkButton buttonText={'戻る'} buttonUrl={'/users'}/>
                </ButtonGroup>
            </div>
            <Box className='admin-box'>
                <AddUserForm />
            </Box>
        </>   
    ) 
}
